import { items, isArray } from 'ldash';
export const toQueryString = (params)=>{
    let search = new URLSearchParams();
    for (let [key, value] of items(params || {})){
        if (value === undefined) {
            continue;
        }
        if (isArray(value)) {
            value.forEach((v)=>{
                if (v !== undefined) {
                    search.append(key, v === null ? '' : `${v}`);
                }
            });
        } else {
            search.append(key, value === null ? '' : `${value}`);
        }
    }
    return search.toString();
};
